import React, { useEffect, useState } from "react";
import TextInput from "view/pages/MyProfile/Components/Inputs/TextInput";
import MultiSelect from "view/components/Multiselect";
import { RadioGroup } from "@mui/material";
import { RadioBtn } from "Components/RadioBtn";
import BpCheckbox from "view/components/CheckBox";
import axios from "axios";
import { MaterialUiSelect } from "../Select";
import { getDropdown } from "./ConditionDropdown";
import { MetaInfo } from "./types";
import DynamicMatrixFilterInputs from "./DynamicMatrixFilterInputs";

const RenderedInput: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  const type = values.otherQueryFilter[rowIndex].inputType;
  return (
    <TextInput
      label=""
      type={type}
      name={`otherQueryFilter[${rowIndex}].value`}
      setFieldValue={setFieldValue}
      value={values?.otherQueryFilter[rowIndex]?.value}
      error={otherQueryFilterErrors?.value}
      touched={otherQueryFilterTouched}
      handleChange={(e: any) => {
        const value =
          type === "range" ? Number(e.target.value) : e.target.value;
        setFieldValue(`otherQueryFilter[${rowIndex}].value`, value);
      }}
      handleBlur={handleBlur}
      inputClassName="rounded-[4px] "
    />
  );
};

const RenderedDropdown: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (values?.otherQueryFilter[rowIndex]?.metaInfo)
      processTheMetaInfo(
        values?.otherQueryFilter[rowIndex]?.type,
        values?.otherQueryFilter[rowIndex]?.metaInfo,
      )
        .then((res: any) => {
          setOptions(res);
        })
        .catch(() => {
          setOptions([]);
        });
  }, [values?.otherQueryFilter]);

  return (
    <MaterialUiSelect
      options={options}
      labelKey="text"
      valueKey="value"
      initialValue={values?.otherQueryFilter?.[rowIndex]?.value?.value}
      error={otherQueryFilterErrors?.value}
      handleChange={(value: any) => {
        setFieldValue(`otherQueryFilter[${rowIndex}].value`, value);
      }}
      width="100%"
      className="border-none captitalize"
    />
  );
};

const RenderedRadiogroup: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (values?.otherQueryFilter[rowIndex]?.metaInfo)
      processTheMetaInfo(
        values?.otherQueryFilter[rowIndex]?.type,
        values?.otherQueryFilter[rowIndex]?.metaInfo,
      )
        .then((res: any) => {
          setOptions(res);
        })
        .catch(() => {
          setOptions([]);
        });
  }, [values?.otherQueryFilter]);

  const updateRadioGroupAnswer = (e: any) => {
    const { value } = e.target;

    setFieldValue(
      `otherQueryFilter[${rowIndex}].value`,
      options.find((item: any) => item.value.toString() === value),
    );
  };
  return (
    <div className="flex flex-col">
      <RadioGroup
        row
        onBlur={handleBlur}
        onChange={updateRadioGroupAnswer}
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={
          values?.otherQueryFilter?.[rowIndex]?.value?.["value"] ?? ""
        }
        name="preferred_unit"
      >
        {options.map((item: any) => {
          return (
            <p className=" dark:text-textMain">
              <RadioBtn
                value={item.value}
                labelContent={
                  <span
                    className=""
                    style={{
                      fontSize: "15px",
                      fontWeight: "400",
                    }}
                  >
                    {item.label ?? item.text}
                  </span>
                }
              />
            </p>
          );
        })}
      </RadioGroup>
    </div>
  );
};

const RenderedCheckboxes: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (values?.otherQueryFilter[rowIndex]?.metaInfo)
      processTheMetaInfo(
        values?.otherQueryFilter[rowIndex]?.type,
        values?.otherQueryFilter[rowIndex]?.metaInfo,
      )
        .then((res: any) => {
          setOptions(res);
        })
        .catch(() => {
          setOptions([]);
        });
  }, [values?.otherQueryFilter]);
  return (
    <div className="flex flex-col gap-2">
      <div className="grid items-center grid-cols-2 gap-x-2 gap-y-1">
        {options.map((item: any) => {
          return (
            <div
              className="flex items-center gap-[5px]"
              key={item.value}
              style={{ wordBreak: "break-all" }}
            >
              <BpCheckbox
                onChange={(event) => {
                  const newValue = { ...values.otherQueryFilter[rowIndex] };
                  const previousValues = newValue.value || [];
                  let updatedValues;
                  if (event.target.checked) {
                    updatedValues = [...previousValues, item.value];
                  } else {
                    updatedValues = previousValues.filter(
                      (val: any) => val !== item.value,
                    );
                  }
                  setFieldValue(
                    `otherQueryFilter[${rowIndex}].value`,
                    updatedValues,
                  );
                }}
                checked={values?.otherQueryFilter?.[rowIndex]?.value?.includes(
                  item.value,
                )}
                label={item.label ?? item.text}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const RenderedTagbox: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (values?.otherQueryFilter[rowIndex]?.metaInfo)
      processTheMetaInfo(
        values?.otherQueryFilter[rowIndex]?.type,
        values?.otherQueryFilter[rowIndex]?.metaInfo,
      )
        .then((res: any) => {
          setOptions(res);
        })
        .catch(() => {
          setOptions([]);
        });
  }, [values?.otherQueryFilter]);

  const transformDataToMuiOptions = (options: any) => {
    return options?.map((option: any) => ({
      name: option.label ?? option.text,
      id: option.value ?? option.id,
      optionID: option.value ?? option.id,
    }));
  };

  const defaultSelectedOptions = () => {
    const selectedValues = values?.otherQueryFilter[rowIndex]?.value || [];
    return selectedValues
      .map((selected: any) => {
        return options.find((option: any) => option.value === selected);
      })
      .filter(Boolean);
  };

  return (
    <MultiSelect
      options={transformDataToMuiOptions(options)}
      inputValue=""
      onInputChange={() => {}}
      defaultValue={{ value: "", label: "" }}
      isMulti
      value={defaultSelectedOptions()}
      onChange={(selected: any) => {
        const selectedList = Array.isArray(selected) ? selected : [];
        setFieldValue(
          `otherQueryFilter[${rowIndex}].value`,
          transformDataToMuiOptions(selectedList).map(
            (item: any) => item?.optionID ?? item?.id,
          ),
        );
      }}
    />
  );
};

const RenderedInputRadio: React.FC<any> = ({
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  return (
    <div className="py-3">
      <MaterialUiSelect
        options={[
          { label: "Any Value", value: "Any Value" },
          { label: "No Value", value: "No Value" },
          { label: "Custom Value", value: "Custom Value" },
        ]}
        labelKey="label"
        valueKey="value"
        error={otherQueryFilterErrors?.value}
        initialValue={values?.otherQueryFilter[rowIndex]?.value}
        handleChange={(value: any) => {
          setFieldValue(`otherQueryFilter[${rowIndex}].value`, value.value);
        }}
        width="100%"
        className="border-none captitalize"
      />
    </div>
  );
};

const RenderedCheckbox: React.FC<any> = ({
  label = "True",
  rowIndex,
  values,
  handleBlur,
  setFieldValue,
  otherQueryFilterErrors,
  otherQueryFilterTouched,
  handleChange,
}) => {
  return (
    <BpCheckbox
      onChange={(event) => {
        setFieldValue(
          `otherQueryFilter[${rowIndex}].value`,
          event.target.checked,
        );
      }}
      checked={values?.otherQueryFilter?.[rowIndex]?.value}
      label={label}
    />
  );
};

function transformData(items: any) {
  if (Array.isArray(items)) {
    return items.map((p: any) =>
      typeof p === "string"
        ? { label: p, value: p }
        : { label: p?.text, value: p?.value },
    );
  }
  return [];
}

async function processTheMetaInfo(type: string, meta: MetaInfo) {
  try {
    let data: any = [];

    if (meta.choicesByUrl) {
      const response = await axios.get(meta.choicesByUrl.url);
      data = response.data;
    } else {
      data = meta.choices;
    }

    if (["radiogroup", "checkbox", "dropdown", "tagbox"].includes(type)) {
      return data;
    } else {
      return transformData(data);
    }
  } catch (error) {
    console.error("Error processing the meta info:", error);
    return [];
  }
}

const renderComponentByType = (
  index: number,
  values: any,
  setFieldValue: any,
  otherQueryFilterErrors: any,
  otherQueryFilterTouched: any,
  handleChange: any,
  handleBlur: any,
  setFieldTouched: any,
  availableColumns: any[] = [],
) => {
  switch (values?.otherQueryFilter[index].type) {
    case "dropdown":
      return (
        <div className="w-full max-w-[25%]">
          <RenderedDropdown
            rowIndex={index}
            values={values}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            otherQueryFilterErrors={otherQueryFilterErrors}
            otherQueryFilterTouched={otherQueryFilterTouched}
            handleChange={handleChange}
          />
        </div>
      );
    case "radiogroup":
      return (
        <RenderedRadiogroup
          rowIndex={index}
          className=""
          values={values}
          setFieldValue={setFieldValue}
          otherQueryFilterErrors={otherQueryFilterErrors}
          otherQueryFilterTouched={otherQueryFilterTouched}
          handleChange={handleChange}
        />
      );

    case "checkbox":
      return (
        <RenderedCheckboxes
          rowIndex={index}
          className=""
          values={values}
          setFieldValue={setFieldValue}
          otherQueryFilterErrors={otherQueryFilterErrors}
          otherQueryFilterTouched={otherQueryFilterTouched}
          handleChange={handleChange}
        />
      );

    case "tagbox":
      return (
        <div className="w-full py-3">
          <RenderedTagbox
            rowIndex={index}
            className=""
            values={values}
            setFieldValue={setFieldValue}
            otherQueryFilterErrors={otherQueryFilterErrors}
            otherQueryFilterTouched={otherQueryFilterTouched}
            handleChange={handleChange}
          />
        </div>
      );

    case "gpsCoordinates":
      // handled upstream in main render
      return null;
    case "matrixdynamic": {
      const selectedMatrixColumn = availableColumns.find(
        (column) => column.column === values?.otherQueryFilter[index]?.column,
      );
      return (
        <DynamicMatrixFilterInputs
          rowIndex={index}
          values={values}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          metaInfo={selectedMatrixColumn?.metaInfo}
          otherQueryFilterErrors={otherQueryFilterErrors}
          otherQueryFilterTouched={otherQueryFilterTouched}
        />
      );
    }
    case "text":
      return (
        <div className="w-full">
          <RenderedInput
            rowIndex={index}
            className=""
            values={values}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            otherQueryFilterErrors={otherQueryFilterErrors}
            otherQueryFilterTouched={otherQueryFilterTouched}
            handleChange={handleChange}
          />
        </div>
      );

    default:
      return (
        <div className="w-full">
          <RenderedInput
            rowIndex={index}
            className=""
            values={values}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            otherQueryFilterErrors={otherQueryFilterErrors}
            otherQueryFilterTouched={otherQueryFilterTouched}
            handleChange={handleChange}
          />
        </div>
      );
  }
};

export {
  RenderedInput,
  RenderedDropdown,
  RenderedRadiogroup,
  RenderedCheckboxes,
  RenderedTagbox,
  RenderedInputRadio,
  RenderedCheckbox,
  processTheMetaInfo,
  transformData,
  renderComponentByType,
};
